import { useContext } from 'react';
import { createCtx } from '@shared/util/context';
import type { NavStack, Route } from './types';

const navStackTuple = createCtx<NavStack>();
export const NavStackContextProvider = navStackTuple[1];
export const NavStackContext = navStackTuple[2];

type ExtractRouteName<TRoute> = TRoute extends { name: infer RouteName } ? RouteName : string;
export type { ExtractRouteName };

/**
 * Hook to access the navigation stack from context.
 * Requires a type parameter for type safety:
 *
 * - useNavStackContext<TRoute>() - returns typed NavStack with typed currentRoute
 */
export function useNavStackContext<TRoute extends Route<string>>(): NavStack<
  ExtractRouteName<TRoute>
> & {
  currentRoute: TRoute | undefined;
} {
  const ctx = useContext(NavStackContext);
  if (!ctx) {
    throw new Error('useNavStackContext must be used within a MBNavStackProvider');
  }
  return ctx as NavStack<ExtractRouteName<TRoute>> & { currentRoute: TRoute | undefined };
}
